module.exports = __webpack_public_path__ + "img/미국국기.8f7e930b.png";